var nativeCreate = require('./_nativeCreate');


function hashClear() {
  this.__data__ = nativeCreate ? nativeCreate(null) : {};
  this.size = 0;
}

module.exports = hashClear;



//////////////////
// WEBPACK FOOTER
// ./node_modules/lodash/_hashClear.js
// module id = 1750
// module chunks = 0